import { gql } from '@apollo/client'

export const ADD_DEVICE_TO_USER = gql`
  mutation AddDeviceToUser($input: AddDeviceToUserInput!) {
    addDeviceToUser(input: $input) {
      success
      errors
    }
  }
`

export const UNLINK_DEVICE = gql`
  mutation UnlinkDevice($input: UnlinkDeviceInput!) {
    unlinkDevice(input: $input) {
      success
      errors
    }
  }
`
